/**
 * Turns a owner email into a display name: `first.second@go-electra.com` →
 * `First Second`. There is no user table backing `owner_id` (it is the
 * owner's lowercased email), so the name is derived from the local part.
 * Anything that isn't a parseable email is returned unchanged.
 */
export function formatOwnerName(email: string): string {
  const localPart = email.split('@')[0];
  if (localPart === '' || localPart === email) return email;

  const name = localPart
    .split(/[._-]+/)
    .filter((part) => part !== '')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

  return name === '' ? email : name;
}
